// extracted by mini-css-extract-plugin
module.exports = {"container":"FormSelect_container__1A3ij","label":"FormSelect_label__2v8G3"};